module.exports = __webpack_public_path__ + "static/media/recommend.96616b26.svg";